<template>
  <div class="page-content-mobile">
    <div class="join-us">
      <div class="join-us-content">
        <div class="join-us-title">
          预约深度演示 获取行业定制方案
        </div>
        <div class="join-us-btn" @click="showSubscribeModal = true">
          立即预约
        </div>
      </div>
    </div>

    <!-- 预约弹窗组件 -->
    <SubscribeModal :visible="showSubscribeModal" @close="showSubscribeModal = false" />

    <div class="footer">
      <div class="footer-content">
        <div class="footer-content-top">
          <div class="logo">
            <img class="zhkj" src="../../../assets/img/com/mobile/zhkj.png" alt="">
          </div>
          <div class="qr-code">
            <div class="code-box">
              <img src="../../../assets/img/com/pc/dy_code.png" alt="抖音号">
              <span>官方抖音号</span>
            </div>
            <div class="code-box">
              <img src="../../../assets/img/com/pc/gzh_code.png" alt="微信号">
              <span>免费试用</span>
            </div>
            <div class="code-box">
              <img src="../../../assets/img/com/pc/xhs_code.png" alt="小红书">
              <span>官方小红书</span>
            </div>
          </div>
        </div>
      </div>
      <div class="copyright">
        <div class="address">
          试用热线:13212750978
        </div>
        <div class="address">
          <img class="addres-img" src="@/assets/img/com/mobile/address_icon.png" alt="定位">
          <span class="lable">地址</span>
          <span @click="openNavigation" class="address-text">湖北省武汉市江汉区泛海国际SOHO城2栋2608</span>
        </div>
        <div>
          <span>©Copyright 2025 湖北智寰科技有限公司</span>
          <a href="https://beian.miit.gov.cn" target="_blank" class="icp-link">鄂ICP备2025109804号-1</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubscribeModal from './SubscribeModalMobile.vue'

export default {
  name: 'footerMobile',
  components: {
    SubscribeModal
  },
  data() {
    return {
      showSubscribeModal: false
    }
  },
  watch: {
    showSubscribeModal(newVal) {
      if (newVal) {
        // 弹窗打开时禁止背景滚动
        this.disableBodyScroll()
      } else {
        // 弹窗关闭时恢复背景滚动
        this.enableBodyScroll()
      }
    }
  },
  methods: {
    disableBodyScroll() {
      // 保存当前滚动位置
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop
      // 禁止body滚动
      document.body.style.position = 'fixed'
      document.body.style.top = `-${this.scrollTop}px`
      document.body.style.width = '100%'
      document.body.style.overflow = 'hidden'
    },
    enableBodyScroll() {
      // 恢复body样式
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
      document.body.style.overflow = ''
      // 恢复滚动位置
      if (this.scrollTop !== undefined) {
        window.scrollTo(0, this.scrollTop)
      }
    },
    openNavigation() {
      const address = '湖北省武汉市江汉区黄孝西路1号'
      const lat = '30.5928'
      const lng = '114.3048'
      const userAgent = navigator.userAgent.toLowerCase()

      if (/micromessenger/.test(userAgent)) {
        // 微信内置浏览器 - 使用腾讯地图导航
        const tencentUrl = `https://apis.map.qq.com/uri/v1/routeplan?type=drive&to=${encodeURIComponent(address)}&tocoord=${lat},${lng}&policy=1`
        window.location.href = tencentUrl
      } else if (/iphone|ipad|ipod/.test(userAgent)) {
        // iOS 设备 - 直接使用苹果地图导航
        const appleMapUrl = `maps://maps.apple.com/?daddr=${lat},${lng}&dirflg=d`
        window.location.href = appleMapUrl
      } else if (/android/.test(userAgent)) {
        // Android 设备 - 优先使用高德地图导航
        const gaodeUrl = `androidamap://route?sourceApplication=智寰科技&dlat=${lat}&dlon=${lng}&dname=${encodeURIComponent(address)}&dev=0&t=0`

        // 尝试打开高德地图
        try {
          window.location.href = gaodeUrl
        } catch (e) {
          // 如果高德地图无法打开，使用百度地图
          const baiduUrl = `baidumap://map/direction?destination=latlng:${lat},${lng}|name:${encodeURIComponent(address)}&mode=driving`
          window.location.href = baiduUrl
        }
      } else {
        // 桌面端 - 打开高德地图网页版并自动搜索
        const gaodeWebUrl = `https://ditu.amap.com/place/B0FFHSSJXJ?q=${encodeURIComponent(address)}`
        window.open(gaodeWebUrl, '_blank')
      }
    },

  },
  beforeDestroy() {
    // 组件销毁前确保恢复滚动
    this.enableBodyScroll()
  }
}
</script>

<style scoped lang="scss">
@use '@/styles/mobile-responsive.scss' as mobile;

.page-content-mobile {
  .join-us {
    width: 100%;
    height: mobile.px2rem(100);
    background: url('../../../assets/img/com/mobile/footer_bg.png') no-repeat center center;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;

    .join-us-content {
      width: 100%;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .join-us-title {
        font-weight: bold;
        font-size: mobile.px2rem(16);
        color: #333333;
        margin-bottom: mobile.px2rem(14);
      }

      .join-us-btn {
        width: mobile.px2rem(76);
        height: mobile.px2rem(24);
        line-height: mobile.px2rem(24);
        background: linear-gradient(90deg, #00A1FF 0%, #0F3FFF 100%);
        border-radius: mobile.px2rem(2);
        font-weight: 500;
        font-size: mobile.px2rem(12);
        color: #FFFFFF;
        text-align: center;
        cursor: pointer;
        margin: 0 auto;
      }
    }
  }

  .footer {
    width: 100%;
    background: #1F231F;
    position: relative;
    padding: mobile.px2rem(24) mobile.px2rem(0) mobile.px2rem(30);

    .footer-content {
      width: 100%;

      .footer-content-top {

        .logo {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: mobile.px2rem(20);

          .zhkj {
            width: mobile.px2rem(224);
            height: mobile.px2rem(35);

          }
        }

        .qr-code {
          display: flex;
          justify-content: center;
          gap: mobile.px2rem(40);
          margin-bottom: mobile.px2rem(26);

          .code-box {
            display: flex;
            flex-direction: column;
            align-items: center;

            img {
              width: mobile.px2rem(58);
              height: mobile.px2rem(58);
              border-radius: mobile.px2rem(2);
              margin-bottom: mobile.px2rem(4);
            }

            span {
              font-weight: 500;
              font-size: mobile.px2rem(12);
              color: #FFFFFF;
            }
          }
        }
      }

    }

    .copyright {
      width: 100%;
      text-align: center;
      font-weight: 400;
      font-size: mobile.px2rem(12);
      color: #FFFFFF;

      .address {
        margin-bottom: mobile.px2rem(10);
        line-height: mobile.px2rem(12);

        .lable {
          margin-right: mobile.px2rem(4);
        }

        .addres-img {
          width: mobile.px2rem(12);
          height: mobile.px2rem(12);
          vertical-align: middle;
          margin-right: mobile.px2rem(4);
        }

        .address-text {
          cursor: pointer;
          text-decoration: underline;
          color: #FFFFFF;

          &:hover {
            opacity: 0.8;
          }

          &:active {
            opacity: 0.6;
          }
        }
      }

      .icp-link {
        color: #FFFFFF;
        text-decoration: none;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>